import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  container: {
    marginVertical: 6,
    marginHorizontal: Platform.select({
      web: 16,
      default: 8,
    }),
  },
  fragment: {
    borderRadius: 6,
    borderWidth: 1,
    borderEndWidth: 2,
    borderBottomWidth: 4,
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  fragmentText: {
    fontSize: 16,
    textAlign: 'center',
  },
  placeholder: {
    borderRadius: 6,
    borderWidth: 1,
    paddingVertical: 4,
    paddingHorizontal: 8,
    margin: 8,
    height: 40,
  },
  optionKeyContainer: {
    position: 'absolute',
    right: -12,
    top: -2,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionKey: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: 6,
    borderWidth: 1,
    borderBottomWidth: 3,
  },
});
